var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:_vm.color + '_svg',style:(_vm.styling),attrs:{"src":_vm.iconName,"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }